import { getCities, getProvinces } from "api/queries/location"
import {
    UseQueryResult,
    useQuery,
} from "react-query";
import ICityParams from "rules/interface/api/city/city-params.interface";
import { IServerGetResponse } from "rules/interface/api/response";
import { ICity } from "rules/interface/city/city.interface";
import { IProvince } from "rules/interface/province/province.interface";


export function useGetProvinces(): UseQueryResult<IServerGetResponse<IProvince[]>> {
    return useQuery(
        ["provinces"],
        () => getProvinces(), {
        staleTime: 1000 * 60 * 60 * 24 * 7 // cache 1 week
    });
}


interface ICityProps {
    params?: ICityParams
    city?: string
    enabled?: boolean
}

export function useGetCities(props: ICityProps): UseQueryResult<IServerGetResponse<ICity[]>> {
    return useQuery(["cities", props], () => getCities(props), {
        enabled: (props?.enabled && typeof props?.enabled === "undefined") ? true : Boolean(props?.enabled),
        staleTime: props.params?.province ? 0 : 1000 * 60 * 60 * 24 * 7 // cache 1 week
    });
}

export function useGetCity(props: ICityProps): UseQueryResult<IServerGetResponse<ICity>> {
    return useQuery(["city", props], () => getCities(props), {
        enabled: props?.enabled === undefined ? true : Boolean(props?.enabled),
        staleTime: 1000 * 60 * 60 * 24 * 7 // cache 1 week
    });
}